import React from "react";
import { FontList } from "./fontList";

export const PhoenixDigitalArtFont = () => {

    const fonts = [
        "ThitSarShweSi"
    ];

    return (
        <FontList title="Phoenix Digital Art Font Preview" data={fonts} categoryKey="phoenix-digital-art" />
    );
};
